module.exports = __webpack_public_path__ + "e9b2b0bb2084404cd1bfb70758c0109b.svg";